module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/logo_jsnt-5187bb1724eee5da8f610b7148b141ba.svg";